import { deleteRequest, get, patch, post } from "./api";

const getRoyalties = (customerId) => {
  return get(`/api/v2/customers/${customerId}/royalty/`);
};

const updateRoyalties = (customerId, royaltyId, data) => {
  return patch(`/api/v2/customers/${customerId}/royalty/${royaltyId}/`, data);
};

const createRoyalties = (customerId, data) => {
  return post(`/api/v2/customers/${customerId}/royalty/`, data);
};

const deleteRoyalties = (customerId, royaltyId) => {
  return deleteRequest(`/api/v2/customers/${customerId}/royalty/${royaltyId}/`);
};

export { getRoyalties, updateRoyalties, createRoyalties, deleteRoyalties };